import { useContext, useEffect } from "react";
import { isEmpty } from "lodash";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { Icon } from "@iconify/react/dist/iconify.js";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import TableFilter from "../../../components/TableFilter";
import PaginationComponent from "../../../components/Pagination";
import SearchTable from "../../../components/SearchTable";
import EmptyData from "../../../components/EmptyData";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { convertDate } from "../../../utils";
import {
  convertNotificationTypeToColor,
  convertNotificationTypeToIcon,
} from "../../../utils/enum";
import { notificationUserContext } from "../../../context/UserContext/NotificationUserContext/NotificationUserContext";

const NotificationsUser = () => {
  const {
    notifications,
    notification,
    setNotification,
    sort,
    setSort,
    filter,
    setFilter,
    pageCount,
    itemsCount,
    setItemsCount,
    pageNumber,
    setPageNumber,
    handleGetNotifications,
    handleReadNotification,
    handleReadAllNotification,
    handleDeleteNotification,
    handleDeleteAllNotification,
  } = useContext(notificationUserContext);

  useEffect(() => {
    handleGetNotifications();
  }, [pageNumber, itemsCount, sort]);

  return (
    <>
      <SiteTitle title="اعلان ها" />

      <TableFilter
        setItemsCount={setItemsCount}
        itemsCount={itemsCount}
        setSort={setSort}
        sort={sort}
      />

      <div className="card h-100 p-0 radius-12">
        <SearchTable
          endItem={
            <div className="d-flex gap-2">
              {!isEmpty(notifications) && (
                <button
                  title="حذف همه"
                  className="btn btn-danger radius-8 d-flex align-items-center"
                  onClick={() =>
                    areYouSureMessage(
                      handleDeleteAllNotification,
                      `آیا از حذف همه اطلاعیه ها مطمئنید؟`
                    )
                  }
                >
                  <Icon icon="fa:trash" className="text-xl" />
                </button>
              )}
              {!isEmpty(notifications?.filter((_n) => !_n?.isRead)) && (
                <button
                  title="خواندن همه"
                  className="btn btn-primary radius-8 d-flex align-items-center"
                  onClick={() =>
                    areYouSureMessage(
                      handleReadAllNotification,
                      `آیا از ویرایش اطلاعیه ها به خوانده شده مطمئنید؟`
                    )
                  }
                >
                  <Icon
                    icon="fa6-solid:envelope-open-text"
                    className="text-xl"
                  />
                </button>
              )}
            </div>
          }
          filter={filter}
          setFilter={setFilter}
          onSearch={handleGetNotifications}
        />
        <div className="card-body p-24">
          {isEmpty(notifications) ? (
            <EmptyData />
          ) : (
            <>
              <div className="table-responsive scroll-sm">
                <table className="table bordered-table sm-table mb-0">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">عنوان</th>
                      <th scope="col">تاریخ</th>
                      <th scope="col">ساعت</th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody>
                    {notifications.map((item, index) => {
                      const color = convertNotificationTypeToColor(item.type);
                      const prefixClass = item.isRead ? "" : `bg-info-50`;
                      return (
                        <tr>
                          <td className={prefixClass}>{index + 1}</td>
                          <td className={prefixClass}>
                            <div className="d-flex align-items-center gap-3">
                              <span
                                className={`w-44-px h-44-px bg-${color}-subtle text-${color}-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0`}
                              >
                                <Icon
                                  icon={convertNotificationTypeToIcon(
                                    item.type
                                  )}
                                  className="icon text-xxl"
                                />
                              </span>
                              <span className="text-nowrap text-line-1">
                                {item.title}
                              </span>
                            </div>
                          </td>
                          <td className={prefixClass}>
                            {convertDate(item.createdAt, "jYYYY/jMM/jDD")}
                          </td>
                          <td className={prefixClass}>
                            {convertDate(item.createdAt, "HH:mm:ss")}
                          </td>
                          <td className={prefixClass}>
                            <div className="dropdown">
                              <button
                                className="hover-bg-transparent"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <Icon
                                  icon="ph:dots-three-outline-fill"
                                  className="menu-icon"
                                />
                              </button>
                              <ul className="dropdown-menu list">
                                <li
                                  onClick={() => {
                                    setNotification(item);
                                    !item.isRead &&
                                      handleReadNotification(item._id);
                                  }}
                                  className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 cursor-pointer"
                                >
                                  جزئیات
                                </li>

                                <li className="dropdown-divider" />
                                <li
                                  onClick={() =>
                                    areYouSureMessage(
                                      () => handleDeleteNotification(item._id),
                                      `آیا از حذف اطلاعیه ${item.title} مطمئنید؟`
                                    )
                                  }
                                  className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900 cursor-pointer text-danger"
                                >
                                  حذف
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              <PaginationComponent
                pageCount={pageCount}
                currentPage={pageNumber}
                setPageNumber={setPageNumber}
              />
            </>
          )}
        </div>
      </div>

      <Modal
        show={!isEmpty(notification)}
        className="modal-dialog-centered"
        size="lg"
        onHide={() => setNotification({})}
      >
        <ModalHeader closeButton>
          <span className="fs-5 fw-bold">{notification?.title}</span>
        </ModalHeader>
        <ModalBody>
          <p className="text-pre-wrap">{notification?.description}</p>
          <p className="text-end">
            {convertDate(notification.createdAt, "jYYYY/jMM/jDD - HH:mm:ss")}
          </p>
        </ModalBody>
      </Modal>
    </>
  );
};

export default NotificationsUser;
